<template>
    <v-snackbar v-if="active"
                :class="typeof(elementClass)==='undefined' ? '' : elementClass"
                dark
                multi-line
                :timeout="timeout"
                :top="vPosition === 'top'"
                :bottom="vPosition === 'bottom'"
                :right="hPosition === 'right'"
                :left="hPosition === 'left'"
                :color="color"
                v-model="active"
    >
        <span v-html="text"></span>
        <v-btn class="white--text" style="margin-right: -16px;" fab flat @click.native="active = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
</template>

<script>
export default {
    name: 'app-snackbar',
    data: function () {
        return {
            active: false,
            color: 'blue',
            vPosition: 'top',
            hPosition: 'right',
            timeout: 6000,
            text: null,
            elementClass: null,
        }
    },
    created: function() {
        this.$bus.$on('app.showSnackbar', (params) => {
            this.showSnackbar(params);
        });
        this.$bus.$on('app.hideSnackbar', () => {
            this.active = false;
        });
    },
    methods: {
        showSnackbar: function (params) {
            this.active = true;
            this.color = (typeof (params.color) === 'undefined') ? 'blue' : params.color;
            this.vPosition = (typeof (params.vPosition) === 'undefined') ? 'top' : params.vPosition;
            this.hPosition = (typeof (params.hPosition) === 'undefined') ? 'right' : params.hPosition;
            this.timeout = (typeof (params.timeout) === 'undefined') ? 3000 : params.timeout;
            this.text = (typeof (params.text) === 'undefined') ? '' : params.text;
            this.elementClass = (typeof (params.class) === 'undefined') ? null : params.class;
        },
    },
};
</script>
